import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';

export interface EaFilterOption {
  key: string;
  label: string;
}

@Component({
  selector: 'ea-filter-dropdown',
  templateUrl: './filter-dropdown.component.html',
  styleUrls: ['./filter-dropdown.component.scss'],
  standalone: false,
})
export class EaFilterDropdownComponent {
  @Input() label = '';
  @Input() options: readonly EaFilterOption[] = [];
  @Input() value = '';
  @Output() valueChange = new EventEmitter<string>();

  open = false;

  constructor(private host: ElementRef) {}

  get currentLabel(): string {
    return this.options.find(o => o.key === this.value)?.label || '';
  }

  toggle() {
    this.open = !this.open;
  }

  pick(key: string) {
    this.open = false;
    if (key !== this.value) this.valueChange.emit(key);
  }

  @HostListener('document:click', ['$event'])
  closeOnOutsideClick(event: MouseEvent) {
    if (this.open && !this.host.nativeElement.contains(event.target)) {
      this.open = false;
    }
  }

  @HostListener('document:keydown.escape')
  closeOnEscape() {
    this.open = false;
  }
}
